import { createMutationHook } from '~/shared/providers/api';

export const useDeleteFacilityGroupMutation = createMutationHook(
  'facilities.facilityGroupDelete',
  (params: { id: string }) => ({
    coreFacilityGroupDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
